import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const School = () => {
    const { t } = useTranslation();

    return (
        <div className="p-4">
            <div className="w-full max-w-[900px] mx-auto">
                <div className="border-primary border rounded-2xl p-8 md:p-12">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                        {/* Left side - Text content */}
                        <div className="flex-1 space-y-6">
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
                                {t("school.title")}
                            </h2>
                            <p className="text-lg text-gray-700">{t("school.subtitle")}</p>
                            <Link
                                to="/for-schools"
                                className="inline-block bg-primary hover:bg-purple-600 text-white font-semibold px-8 py-3 rounded-lg"
                            >
                                {t("learn-more")}
                            </Link>

                            <div className="pt-4 space-y-3">
                                {[...Array(2)].map((_, idx) => (
                                    <div key={idx} className="flex items-center gap-2">
                                        <svg
                                            className="w-5 h-5 text-green-600 flex-shrink-0"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                        <span className="text-gray-700 font-medium">
                                            {t(`school.feature${idx + 1}`)}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Right side - Image */}
                        <div className="flex-shrink-0 w-full md:w-auto">
                            <img
                                src="https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/school-teacher-talking.svg"
                                alt="Teacher and student illustration"
                                className="w-full md:w-80 lg:w-96 h-auto"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default School;
